import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconReceiptionBell2"><Path d="M14.5 3C14.7761 3 15 3.22386 15 3.5C15 3.77614 14.7761 4 14.5 4H12.502V5.5127C18.3097 5.77887 22 10.6585 22 16.5C22 16.7761 21.7761 17 21.5 17H12.5V19H21.5C21.7761 19 22 19.2239 22 19.5C22 19.7761 21.7761 20 21.5 20H2.5C2.22386 20 2 19.7761 2 19.5C2 19.2239 2.22386 19 2.5 19H11.5V17H2.5C2.22386 17 2 16.7761 2 16.5C2 10.6571 5.69198 5.77687 11.502 5.5127V4H9.5C9.22386 4 9 3.77614 9 3.5C9 3.22386 9.22386 3 9.5 3H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBell2;
